export const OTHER_OPTION = 'Other';

export const REJECTION_OPTIONS = [
  'Suggested keywords are not relevant to my business.',
  'Suggested keywords are overused or forced.',
  'Suggested keywords already incorporated in previous content.',
  'Suggested content is too long.',
  'Suggested content is repetitive or redundant.',
  'Suggested content is factually inaccurate.',
  'Suggested content is not relevant to this section or page.',
  'Suggested content is unclear or poorly written.',
  'Suggested content is too specific and does not align with the purpose of this section.',
  'Suggested content does not match our brand voice.',
  'Previous content general format and structure was lost.',
  'Previous content important information was removed.',
  OTHER_OPTION,
];
